import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { cookies, isStrictlyNecessary, modifyConsentCookie } from '../cookies';
import { tcfApi, CMP_EVENTS, vendors, useTCString } from '../iab-tcf';

const useStyles = makeStyles(theme => ({
  rejectAllButton: {
    padding: theme.spacing(0, 4),
    backgroundColor: theme.palette.error.main,
    borderRadius: theme.shape.borderRadius,
    transition: 'all 0.2s',
    height: 38,
    color: theme.palette.common.white,
  },
}));
function RejectAllButton({ setSelectedCookies, setActiveScreen, onClose }) {
  const classes = useStyles();
  const { refreshTCString } = useTCString();

  const rejectAll = () => {
    // cookies
    const updatedCookies = cookies.reduce((acc, cookie) => {
      return {
        ...acc,
        [cookie.value]: isStrictlyNecessary(cookie.value) ? true : false,
      };
    }, {});
    setSelectedCookies(updatedCookies);
    modifyConsentCookie(updatedCookies);

    // tcf
    vendors.rejectAll();
    refreshTCString();
    tcfApi.triggerCmpEvent(CMP_EVENTS.COMPLETE);

    setActiveScreen('customize');
    onClose({ consentGranted: false });
  };

  return (
    <Button
      variant="contained"
      className={classes.rejectAllButton}
      data-test-id="consent-reject-all"
      onClick={() => rejectAll()}
    >
      Reject All
    </Button>
  );
}

RejectAllButton.propTypes = {
  setSelectedCookies: PropTypes.func.isRequired,
  setActiveScreen: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default RejectAllButton;
